<template>
    <div class="EntityDetailsPropertiesTabCard" :class="{ 'EntityDetailsPropertiesTabCard--editing': editing }">
        <div class="EntityDetailsPropertiesTabCard__header">
            <span class="EntityDetailsPropertiesTabCard__title">
                <slot name="title">{{ title }}</slot>
            </span>
            <slot name="titleRight" />
        </div>
        <div
            class="EntityDetailsPropertiesTabCard__body"
            :class="{ 'EntityDetailsPropertiesTabCard__body--collateral': collateral }"
        >
            <slot />
        </div>
    </div>
</template>

<style lang="scss">
    .EntityDetailsPropertiesTabCard {
        background: var(--eidWhite);
        border: 1px solid var(--eidSecureBlue-10);
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &--editing {
            border-color: var(--eidTrustGreen-25);
            box-shadow:
                0 0 0 1px var(--eidTrustGreen-25),
                0 1px 3px rgba(0, 0, 0, 0.06);
        }

        &__header {
            padding: 14px 22px;
            border-bottom: 1px solid var(--eidSecureBlue-10);
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &__title {
            font-family: "Roboto", sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            color: var(--eidQualityBlack);
        }

        &__body {
            padding: 0 22px;

            &--collateral {
                padding: 0;
                overflow-x: auto;
            }
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'EntityDetailsPropertiesTabCard',
        props: {
            title: {
                type: String,
                default: '',
            },
            editing: {
                type: Boolean,
                default: false,
            },
            collateral: {
                type: Boolean,
                default: false,
            },
        },
    });
</script>
